import styled from "@emotion/styled";
export const StyledParagraphWithVideo = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .paragraph-content-title {
    font-size: 1rem;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 24px;
  }

  .paragraph-content-description {
    font-size: 0.875rem;
    line-height: 24px;
  }

  .paragraph-video-wrapper {
    margin-top: 40px;

    .pargraph-video-item {
      width: 100%;
    }
  }
`;
